import { createFileRoute } from "@tanstack/react-router";
import BackButton from "@/components/GoBack";
import Messages from "@/components/Support";
import { useParams } from "@/lib/navigation";

const ChatPage = () => {
  const params = useParams();
  const channelId = params?.id as string | undefined;

  return (
    <div>
      <BackButton />
      <Messages channelId={channelId} />
    </div>
  );
};

export const Route = createFileRoute("/_authenticated/chat/$id/")({
  component: ChatPage,
  staticData: { page: "support" },
});
